export default __webpack_public_path__ + "static/ogX-f8bbe975360509db004b94de3bf2a315.jpg";